import { Directive,ElementRef , AfterViewInit,Input } from '@angular/core';
import {DataService} from './data.service';

@Directive({
  selector: '[appDatePicker]'
})
export class AppDatePickerDirective implements AfterViewInit{
  @Input() options
  constructor(private el:ElementRef,private service:DataService) {

  }

  ngAfterViewInit(){
  let self=this.el.nativeElement;

  if(this.options!=null){
    self.flatpickr(this.options);
  }
  this.service.watchStorage().subscribe(()=>{
    this.options=JSON.parse(sessionStorage.getItem('options'));
    if(this.options!=null){
      self.flatpickr(this.options);
    }
  })


}

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/app-date-picker.directive.ts